import { ConfigurationApi } from "../api/2d/Configuration/ConfigurationApi";
import {
  IRenderConfigImageResponse,
  IRenderConfigurationData,
} from "../api/2d/Configuration/type";
import { StatusName } from "../api/type";
import { IConfigImageData } from "./type";

export class ConfigurationService {
  private configurationApi: ConfigurationApi = new ConfigurationApi();

  public async renderConfigurationImage(
    data: IRenderConfigurationData
  ): Promise<IRenderConfigImageResponse> {
    const response = await this.configurationApi.renderConfiguration(data);

    return response.data;
  }

  public async getConfigurationImage(
    data: IRenderConfigurationData
  ): Promise<IConfigImageData> {
    const response = await this.renderConfigurationImage(data);

    if (response.status === StatusName.SUCCESS) {
      return {
        url: response.imageUrl,
        status: response.status,
      };
    }

    return {
      hash: response.configHash,
      status: response.status,
      url: response.imageUrl || undefined,
    };
  }
}
